import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './index.css';
import { loadOidcIdentity } from './oidc-runtime';

async function bootstrap() {
  const identity = await loadOidcIdentity(import.meta.env.PROD, {
    issuer: import.meta.env.VITE_OIDC_ISSUER,
    clientId: import.meta.env.VITE_OIDC_CLIENT_ID,
  });
  const oidcConfig = {
    authority: identity.issuer,
    client_id: identity.clientId,
    redirect_uri: window.location.origin,
    post_logout_redirect_uri: window.location.origin,
    response_type: 'code',
    scope: ['openid', 'profile', 'email', 'offline_access', 'entitlements'].join(' '),
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    onSigninCallback: () =>
      window.history.replaceState({}, document.title, window.location.pathname),
  };

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AuthProvider {...oidcConfig}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </React.StrictMode>,
  );
}

void bootstrap().catch(() => {
  document.getElementById('root')!.textContent =
    'Die Anmeldung ist derzeit nicht konfiguriert. Bitte wenden Sie sich an den Administrator.';
});
